import authApi from '@api/authApi';
import { ActionButton } from '@components/actionButton';
import useLocalizeError from '@hooks/useLocalizeError';
import { t } from '@i18n';
import { Card, TextInput } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { validations } from '@util/validations';
import { createForm } from 'cross-state/react';
import { useEffect } from 'react';

export const Route = createFileRoute('/_public/forgot-password')({
  component: ForgotPassword,
});

const { Form, Field, useForm, FormState } = createForm({
  defaultValue: {
    email: '',
  },
  validations: {
    email: {
      email: validations.email,
    },
  },
});

function ForgotPassword() {
  const localizeError = useLocalizeError();

  return (
    <Form
      localizeError={localizeError}
      css={{
        flex: 1,
        padding: 'var(--mantine-spacing-md)',
        display: 'grid',
        gridTemplateColumns: 'min(400px, 100%)',
        justifyContent: 'center',
        alignContent: 'center',
      }}
    >
      <Content />
    </Form>
  );
}

function Content() {
  const form = useForm();
  const navigate = useNavigate();

  async function submit() {
    if (!form.validate()) {
      return;
    }

    const { email } = form.getDraft();
    await authApi.forgotPassword(email);

    notifications.show({
      message: t('forgotPassword.done', { email }),
    });

    navigate({ to: '/' });
  }

  useEffect(() => {
    authApi.logout();
  }, []);

  return (
    <>
      <Card
        withBorder
        shadow="md"
        css={{
          display: 'grid',
          gap: '1rem',

          '.validated & input:invalid': {
            borderColor: 'var(--mantine-color-red-6)',
          },
        }}
      >
        <h2>{t('forgotPassword.title')}</h2>

        <Field
          name="email"
          render={(props) => (
            <TextInput
              {...props}
              withAsterisk
              label={t('forgotPassword.email.label')}
              description={t('forgotPassword.email.description')}
              autoComplete="email"
            />
          )}
        />

        <FormState selector={(form) => form.isValid}>
          {(isValid) => (
            <ActionButton type="submit" onClick={submit} color={isValid ? undefined : 'gray'}>
              {t('common.submit')}
            </ActionButton>
          )}
        </FormState>
      </Card>
    </>
  );
}
